import type { ObjectDirective } from 'vue'

const draggable: ObjectDirective = {
  beforeMount(el) {
    el.style.position = 'absolute'
    let startX = 0,
      startY = 0,
      initialMouseX = 0,
      initialMouseY = 0

    const mousemoveHandler = (e: MouseEvent) => {
      const dx = e.clientX - initialMouseX
      const dy = e.clientY - initialMouseY
      el.style.left = `${startX + dx}px`
      el.style.top = `${startY + dy}px`
    }

    const mouseupHandler = () => {
      document.removeEventListener('mousemove', mousemoveHandler)
      document.removeEventListener('mouseup', mouseupHandler)
    }

    el.addEventListener('mousedown', (e: MouseEvent) => {
      startX = el.offsetLeft
      startY = el.offsetTop
      initialMouseX = e.clientX
      initialMouseY = e.clientY
      document.addEventListener('mousemove', mousemoveHandler)
      document.addEventListener('mouseup', mouseupHandler)
      e.preventDefault()
    })
  },
}

export default draggable
